export const DataOverrides: any = {
  Popout: { visibility: false },
  ProgressBar: {
    progress: 0.5,
  },
  AlertInlineMain: {
    isVisible: true,
    style: { width: '100%' },
  },
};

const setVisible = `() => setVisible(false)`;
const emptyFn = `() => {}`;
const visibleState = `visible`;
export const InternalStateControl: any = {
  WarningPopup: {
    onCancel: setVisible,
    isVisible: visibleState,
  },
  Drawer: {
    onClose: setVisible,
    open: visibleState,
  },
  GenericModal: {
    onClose: setVisible,
    isVisible: visibleState,
  },
  AppTitleBar: {
    onButtonClick: emptyFn,
  },
};
